import Vue from 'vue';

// local state
const getDefaultState = () => {
	return {
		value: {
			selection: 0,
			project_id: null,
		},
		project: {
			id: null,
			name: '',
			number: '',
			street: '',
			post_code: '',
			city: '',
			country: null,
			description: '',
			status: null,
			configuration: {
				id: null,
				service_id: null,
				description: '',
				editor: '',
				source: null,
				status: null,
				version: null,
				formula_version: null,
				note: null,
				norms_id: 1,
			},
			contacts: [{
				id: null,
				type: 1,
				form_of_address: null,
				first_name: '',
				last_name: '',
				phone: '',
				mobile: '',
				email: '',
				company_name: null,
				company_street: null,
				company_post_code: null,
				company_city: null,
				company_country: null,
				company_email: null,
				company_website: null,
			}]
		}
	}
};

const state = getDefaultState()

const getters = {

};

const mutations = {
	updateProject (state, project) {
	    state.project = project
	},
	updateValue (state, value) {
	    state.value = value
	},
	resetState (state) {
    	Object.assign(state, getDefaultState())
  	}
};

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
};

export default {
  	namespaced: true,
  	state,
  	getters,
  	actions,
  	mutations,
};